
<div class="my-3"></div>
<app-global-view/>
<div class="my-3"></div>
<app-sample-chart/>
<div class="my-3"></div>
<app-order-travail/>
<div class="my-3"></div>
<app-client-chart/>
<div class="my-3"></div>
<app-rapport-chart/>
<div class="my-3"></div>
